// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Bp-z","slideIn":"Cp-z"};